<template>
  <div id="app">
    <div class="case_div">
      <img class="home_banner" src="../../../static/img/img_news_bg.png" />
      <!-- <div class="div_top_title">
        <p>宏邦资讯</p>
        <p class="p_title_sub">NEWS</p>
      </div> -->
    </div>
    <div class="father-div">
      <el-row class="top-news">
        <el-col :md="10">
          <img :src="List[0].cover" />
        </el-col>
        <el-col :md="1">
          <p></p>
        </el-col>
        <el-col :md="12">
          <el-row :gutter="10">
            <el-col :md="6">
              <div style="margin-top: 3rem">
                <p class="txt-day">
                  {{ getMonth(List[0].activityTime) }}.{{
                    getDay(List[0].activityTime)
                  }}
                </p>
                <p class="txt-year">{{ getYear(List[0].activityTime) }}</p>
              </div>
            </el-col>
            <el-col :md="18">
              <div style="margin-top: 3rem">
                <p class="txt-title">{{ List[0].title }}</p>
                <p class="txt-simple">{{ List[0].simple }}</p>
                <div class="back-div"  @click="navto(List[0].id)">

                  <p >了解更多</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <div v-for="(item, index) in List" :key="index" @click="navto(item.id)" style="cursor:pointer">
        <el-row :gutter="10" v-if="index!=0" class="news-item-div">
          <el-col :md="4">
            <div>
              <p class="txt-day">
                {{ getMonth(item.activityTime) }}.{{
                  getDay(item.activityTime)
                }}
              </p>
              <p class="txt-year">{{ getYear(item.activityTime) }}</p>
            </div>
          </el-col>
          <el-col :md="20">
            <div>
              <p class="txt-title">{{ item.title }}</p>
              <div class="txt-img-div">
                <p class="txt-simple">{{ item.simple }}</p>
                <div class="more"></div>
              </div>
            </div>
          </el-col>
          <!-- <el-col :md="2">
            <div class="right-img">
              <img src="../../../static/img/bannerrighthover.png"/>
            </div>
          </el-col > -->
        </el-row>
        <div class="line" v-if="index!=0"></div>
      </div>
      <div class="more-div" @click="getAllList()" v-show="showMore">
        <p>查看更多</p>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../Pagination.vue";
import ShowLine from "../../components/ShowLine.vue";
export default {
  components: {
    ShowLine,
    Pagination,
  },
  data() {
    return {
      month: "",
      year: "",
      day: "",
      total: 6,
      pageSize: 4,
      currentPageNum: 1,
      totalCount: 0,
      List: [],
      showMore:true,
    };
  },
  computed: {
    currentPage: function () {
      return this.pageIndex;
    },
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  mounted() {
    this.Init();
  },
  methods: {
    Init() {
      if(this.showMore){

        this.getList();
      }else{
        this.getAllList();
      }
    },
    getList() {
      this.$axios
        .get("api/activity/list", {
          params: {
            page: this.currentPageNum,
            limit: this.pageSize,
            type: this.type,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.List = response.data.page.list;
              this.totalCount = response.data.page.totalCount;
              this.total = response.data.page.totalPage;
            }
          }.bind(this)
        );
    },
    getAllList() {
      this.showMore=false;
      this.$axios
        .get("api/activity/list", {
          params: {
            page: this.currentPageNum,
            limit: 100,
            type: this.type,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.List = response.data.page.list;
              this.totalCount = response.data.page.totalCount;
              this.total = response.data.page.totalPage;
            }
          }.bind(this)
        );
    },
    navto(id) {
      // this.$router.push('/News/NewsDetail/id='+id);
      let routeData = this.$router.resolve({
        path: "/News/NewsDetail/id=" + id,
      });
      //window.open(routeData.href, "_blank");
      this.$router.push(routeData.href);
    },
    ChangeActive(active) {
      this.isActive = active;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleCurrentChange(data) {
      this.currentPageNum = data;
      console.log(data);
      this.getList();
    },
    getDay(date) {
      console.log(date.split("-")[2]);
      return date.split("-")[2];
    },
    getMonth(date) {
      console.log(date.split("-")[1]);
      return date.split("-")[1];
    },
    getMonthStr(date) {
      var date = new Date(date);
      console.log(date.toDateString());
      console.log(date.toDateString().split(" ")[1]);
      return date.toDateString().split(" ")[1];
    },
    getYear(date) {
      console.log(date.split("-")[0]);
      return date.split("-")[0];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.case_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.cover_div {
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 0);
  top: 0;
  left: 0;
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  color: white;
  font-size: 4rem;
  font-family: medium;

  p {
    margin-bottom: 0;
    user-select: none;
  }

  .p_title_sub {
    position: absolute;
    font-size: 8rem;
    font-family: DIN-Bold;
    margin: 0 1rem;
    color: var(--textWhiteColor20);
  }

  .litter_line_top {
    margin: auto;
    background-color: white;
    height: 1px;
    width: 20%;
  }
}

.father-div {
  padding: 9rem 0;
  width:62.5%;
  margin:auto;
}

.top-news {
  height: 30rem;
  margin-bottom: 10rem;
  box-shadow: 0px 3px 5px 1px rgba(54, 54, 54, 0.1);

  img {
    width: 100%;
    height: 30rem;
    object-fit: cover;
  }
}

.back-div {
  cursor: pointer;
  margin-top: 8rem;
  width: 15rem;
  border-radius: 5rem;
  color: white;
  background: var(--COLORE14B3E3);
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

  p {
    margin: 0;
    font-size: 1.8rem;
  }
}
.more-div{
  cursor pointer;
  background: var(--COLOREF2);
  color: var(--COLORE67);
  font-family: regular;
  font-size: 2rem;
  padding: 1rem;
  text-align: center;
  p{
    margin-bottom:0;
  }
}

.txt-day-center {
  color: var(--COLORE47);
  font-family: DIN-Bold;
  font-size: 4rem;
  line-height: 1;
  text-align: center;

}

.txt-year-center {
  line-height: 1;
  color: var(--COLORE67);
  font-family: DIN-Medium;
  font-size: 1.6rem;
  text-align: center;
}

.txt-day {
  color: var(--COLORE47);
  font-family: DIN-Bold;
  font-size: 4rem;
  line-height: 1;
  text-align: start;
}

.txt-year {
  line-height: 1;
  color: var(--COLORE67);
  font-family: DIN-Medium;
  font-size: 1.6rem;
  text-align: start;
}

.txt-title {
  color: var(--COLORE3B);
  font-family: bold;
  font-size: 2rem;
  text-align: start;
  overflow: hidden; 
  text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; 
}
.txt-img-div{
  display: flex;
  justify-content: space-between;
  .more{
    background-image: url('../../../static/img/bannerright.png');
    background-repeat: no-repeat;
    width:3rem;
    height:3rem;
    //margin-left:3rem;
    background-size: contain;
  }
}
.news-item-div:hover{
  .txt-img-div{
    div{
      background-image: url('../../../static/img/bannerrighthover.png');
    }
  }
}
.txt-simple {
  color: var(--COLORE67);
  font-family: regular;
  font-size: 1.8rem;
  text-align: start;
  width:92%;
  overflow: hidden; 
  text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; 


}

.line {
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
  height: 1px;
  width: 100%;
  background: var(--COLOREA1);
}

@media screen and (min-width: 2000px) {
}

@media screen and (max-width: 1200px) {
  .father-div{
    padding: 9rem 1rem;
  }
}

@media screen and (max-width: 800px) {
}
</style>
